import { useRouter } from "@tanstack/react-router"
import { logout } from "~/features/auth/server/auth.functions"

export const useLogout = () => {
  const router = useRouter()
  return async () => {
    await logout({ data: undefined })
    router.invalidate()
  }
}
